import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Routing service
 */
@Injectable({
  providedIn: 'root'
})
export class AppRoutingService {
  /**
   * Constructor
   * @param router Router
   */
  constructor(private router: Router) { }

  /**
   * Navigate to a rote
   * @param routes The route. Please only use one!
   */
  public navigate(routes: string[]): void {
    if (!routes?.length) {
      return;
    }
    const routeName = routes[0];
    let routePath = '';
    switch (routeName) {
      case 'ProjectValuation': {
        routePath = 'pd';
        break;
      }
      case 'ReportDesigner': {
        routePath = 'rd';
        break;
      }
      case 'Comparables': {
        routePath = 'cmp';
        break;
      }
      case 'Settings': {
        routePath = 'set';
        break;
      }
      case 'Raci': {
        routePath = 'raci';
        break;
      }
      case 'UserDashboard': {
        routePath = 'user-dashboard';
        break;
      }
      case 'Dataverse': {
        routePath = 'dataverse';
        break;
      }
      case 'Status': {
        routePath = 'status';
        break;
      }
      case 'Unauthorized': {
        routePath = 'unauthorized';
        break;
      }
      default: {
        routePath = 'pd';
      }
    }
    this.router.navigate([routePath]);
  }
}
